export default function sniperTransform(input) {
  if (input.length === 0) return input;
  return `▄︻デ${input}══━一`;
}
